import strings from "@/language/Swedish";
export const getHeaderColumnWidth = (item: string): object => {
  switch (item) {
    case strings.table.columns.street:
      return { minWidth: '60px' };
    case strings.table.columns.price:
      return { minWidth: '50px' };
    case strings.table.columns.contractDate:
      return { minWidth: '30px' };
    case strings.table.columns.adDeleteDate:
      return { minWidth: '10px' }; 
    case strings.table.columns.rooms:
      return { maxWidth: '30px' };
    case strings.table.columns.floorFloors:
      return { maxWidth: '40px' };
    case strings.table.columns.livingArea:
      return { maxWidth: '30px' };
    case strings.table.columns.monthlyFeeSqm:
      return { maxWidth: '30px' };
    case strings.table.columns.firm:
      return { minWidth: '60px' };
    case strings.table.columns.ownerName:
      return { minWidth: '55px' };
    case strings.table.columns.ownershipType:
      return { minWidth: '50px' };
    case strings.table.columns.ownerId:
      return { minWidth: '20px' };
    case strings.table.columns.adRegisteredDate:
      return { minWidth: '25px' };
    case strings.table.columns.registeredDate:
      return { minWidth: '25px' };
    case strings.table.columns.advertisingDays:
      return { maxWidth: '20px' };
    case strings.table.columns.adAdvertisingDays:
      return { maxWidth: '20px' };
    default:
      return { width: "auto" };
  }
};